import {
  CheckCSATParams,
  IgnoreCSATParams,
  RespondCSATFeatureParams,
  RespondCSATParams,
  SurveyAction,
} from '../../types/CSAT';
import { cosmosApi } from '../cosmosAPi';
import { getApi } from '../getApi/index';

export const getSurvey = async () => {
  const { data } = await getApi().get<SurveyAction>('/survey/active');

  return data;
};

export const checkCSAT = async ({ user_id, feature_name }: CheckCSATParams) => {
  const { data } = await cosmosApi().post('/v1/csat/check', {
    user_id,
    ...(feature_name && { feature_name }),
  });

  return data;
};

export const respondCSAT = async ({
  user_id,
  rating,
  feedback,
}: RespondCSATParams) => {
  const { data } = await cosmosApi().post('/v1/csat/respond', {
    user_id: user_id,
    rating,
    feedback,
  });

  return data;
};

export const ignoreCSAT = async ({ user_id, feature_name }: IgnoreCSATParams) => {
  const { data } = await cosmosApi().post('/v1/csat/ignore', {
    user_id: user_id,
    feature_name: feature_name,
  });

  return data;
};

export const respondCSATFeature = async ({
  user_id,
  feature_name,
  rating,
  comment,
  canContact,
}: RespondCSATFeatureParams) => {
  const { data } = await cosmosApi().post('/v1/csat/respond', {
    user_id,
    feature_name,
    rating,
    comment,
    canContact,
  });

  return data;
};
